<template>
  <div>
    <div class="d-flex justify-space-between mb-5">
      <div class="d-flex align-center">
        <v-icon color="indigo darken-1" class="mr-3" size="28">mdi-cog</v-icon>
        <h3 class="mb-0">Store Profile</h3>
      </div>

      <div class="d-flex" v-if="storeExisted">
        <router-link :to="{name: 'storeProfileEdit'}" class="router-link ml-4">
          <v-btn outlined color="indigo">
            Edit
          </v-btn>
        </router-link>
      </div>
    </div>

    <div v-if="storeExisted">
      <v-alert
          v-if="!storeProfile"
          type="warning"
          text
          prominent
          dense
      >
        Store profile is now empty.
        <br>
        Edit and enter the store profile information to make your store open to the public.
      </v-alert>

      <StoreProfile
          v-if="storeProfile"
          :storeProfile="storeProfile"
          :nftContract="storeInfo.nftContract"
          class="mb-4"
      ></StoreProfile>

      <StoreInfo
          v-if="storeInfo"
          :store-info="storeInfo"
      ></StoreInfo>
    </div>

    <div v-if="!storeExisted && pageInitialized">
      <v-card class="w-100">
        <v-card-text class="pa-8 d-flex justify-center">
          <div style="max-width: 820px">
            <h3>
              Create your store to receive stablecoin payment and launch NFT schemes for your business
            </h3>
            <v-text-field
                v-model="createStoreForm.nftName"
                outlined
                class="mt-4"
                dense
                label="NFT Name (eg: Decentral Store Token)"
                hide-details
                color="indigo darken-1"
            ></v-text-field>
            <v-text-field
                v-model="createStoreForm.nftSymbol"
                outlined
                class="mt-4"
                dense
                label="NFT Symbol (eg: DST)"
                color="indigo darken-1"
                hide-details
            ></v-text-field>
            <v-btn
                color="indigo darken-3"
                dark
                class="mt-4"
                @click="onclickCreateStoreHandle"
                :loading="createStoreLoading"
                block
            >
              Create Store
            </v-btn>
            <v-btn
                outlined
                class="mt-2"
                block
                rounded
                @click="refreshHandle"
                :loading="refreshLoading"
            >
              <v-icon>mdi-refresh</v-icon>
              Refresh
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <ConfirmationDialog
        :dialogShow="confirmationDialog"
        status="success"
        msg="Success to create store"
        :confirmationCallback="createStoreSuccessCallback"
        btnName="Back"
    >
    </ConfirmationDialog>
  </div>
</template>

<script>
import StoreProfile from "@/components/StoreProfile";
import StoreInfo from "@/components/StoreInfo";
import store from "@/store";
import ethCall from "@/lib/eth/ethCall/index"
import ethUtil from "@/lib/eth/util"
import Vue from 'vue'
import StoreProfileInfoMixin from "@/mixins/StoreProfileInfoMixin";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "ProfileInfo",
  mixins: [StoreProfileInfoMixin],
  components: {
    ConfirmationDialog,
    StoreProfile,
    StoreInfo
  },
  computed: {
    storeExisted: () => store.state.storeInfo,
    pageInitialized: () => !store.state.pageLoading,
    loggedInAccount: () => store.state.loggedInAccount
  },
  data() {
    return {
      createStoreForm: {
        nftName: "",
        nftSymbol: "",
      },
      createStoreLoading: false,
      refreshLoading: false,
      confirmationDialog: false
    }
  },

  async mounted() {
    store.state.pageLoading = true
    await this.getStoreInfoAndProfile(store.state.loggedInAccount)
    store.state.pageLoading = false
  },

  methods: {
    async onclickCreateStoreHandle() {
      this.createStoreLoading = true
      try {
        await ethCall.storeFactory.createStore(
            this.createStoreForm.nftName,
            this.createStoreForm.nftSymbol
        )
        // Vue.notify({type: 'success', text: 'Success to create your store'})
        this.confirmationDialog = true
      } catch (e) {
        const revertMsg = ethUtil.errorMsgHandle(e.message)
        if (revertMsg) {
          e.message = revertMsg
        }
        Vue.notify({
          type: "error",
          text: e.message
        })
      } finally {
        setTimeout(() => {
          this.createStoreLoading = false
        }, 1500)
      }
    },
    createStoreSuccessCallback() {
      window.location.reload()
    },
    refreshHandle() {
      this.refreshLoading = true
      {
        setTimeout(async () => {
          try {
            await this.getStoreInfoAndProfile(store.state.loggedInAccount)
          }catch (e) {
            console.error(e)
          } finally {
            this.refreshLoading = false
          }
        }, 7000)
      }


    }
  }
}
</script>

<style lang="scss" scoped>
.box-sidebar {
  .sidebar-slider {
    .v-messages {
      display: none;
    }
  }
}
</style>